import {useCallback, useEffect, useState} from "react";

import {getOrganizations} from "../../../services/organization";
import {Organization} from "../../../types/Organization";

export const useOrganizations = (userToken: string) => {
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchOrganizations = useCallback(async () => {
    if (!userToken) {
      return;
    }

    setIsLoading(true);
    try {
      const tempOrganizations = await getOrganizations({token: userToken});
      setOrganizations(tempOrganizations);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [userToken]);

  useEffect(() => {
    fetchOrganizations();
  }, [fetchOrganizations]);

  return {
    organizations,
    isLoading,
    fetchOrganizations,
  };
};
